const dateFormat = (date: string | null) => {
  if (!date) return "-";
  const customDate = new Date(date);
  return `${customDate.toLocaleDateString(undefined, {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  })} ${customDate.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

export default dateFormat;
